<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "M4Level",
  props: {
    noGutters: {
      type: Boolean
    },
    noWrap: {
      type: Boolean
    }
  },
  computed: {
    countChildren() {
      let children = this.$slots.default().filter((item) => item.tag != undefined);
      return children.length;
    },
    classes() {
      let classes = ["level"];
      if (this.countChildren === 2) {
        classes.push("level--two-children");
      } else if (this.countChildren === 3) {
        classes.push("level--three-children");
      } else if (this.countChildren === 4) {
        classes.push("level--four-children");
      } else if (this.countChildren >= 5) {
        classes.push("level--fiveplus-children");
      }

      if (this.noGutters) {
        classes.push("level--no-gutters");
      }
      if (this.noWrap) {
        classes.push("level--no-wrap");
      }
      return classes;
    }
  }
};
</script>
